import moment from 'moment'

const ROW_EXAMPLE = {
    name: "Row Name",
    key: "Row-[EquipmentID]-Key",
    mainCells: [
        {
            value: "Value",
            key: "Row-Key"
        }
    ],
    collapseTable: {
        headers: [
            {
                value: "Value",
                key: "Row-Header-Key"
            }
        ],
        rows: [
            {
                cells: [
                    {
                        value: "Value",
                        key: "Row-Cell-Key"
                    }
                ],
                key: "Row-Key"
            }
        ]
    }
}

export function cleanLogsData(shippingLogs, receivingLogs) {

    let equipment = {}
    let rows = []

    // shipping logs
    shippingLogs.forEach(log => {
        if(!(log.equipment.id in equipment)) {
            equipment[log.equipment.id] = {
                name: log.equipment.name,
                logs: []
            }
        }

        equipment[log.equipment.id].logs.push({
            ...log,
            type: "shipping"
        })
    })

    // receiving logs
    receivingLogs.forEach(log => {
        if(!(log.equipment.id in equipment)) {
            equipment[log.equipment.id] = {
                name: log.equipment.name,
                logs: []
            }
        }

        equipment[log.equipment.id].logs.push({
            ...log,
            type: "receiving"
        })
    })

    // loop through keys and create the rows
    Object.keys(equipment).map(equipmentKey => {
        const equipmentItem = equipment[equipmentKey]

        if (equipmentItem) {
            let mainRow = {
                name: equipmentItem.name,
                key: `Row-${equipmentKey}`,
                mainCells: [],
                collapseTable: {
                    rows: []
                }
            }

            let shippedTotal = 0
            let receivedTotal = 0
            let outstanding = 0
    
            // loop through all logs
            equipmentItem.logs.sort((a, b) => {
                const aDate = moment(a.dateAndTime)
                const bDate = moment(b.dateAndTime)

                return bDate.diff(aDate)
            })
            .forEach(log => {

                let logRow = {
                    key: ``,
                    cells: []
                }
                
                // shipping log
                if(log.type == "shipping"){
                    // date
                    logRow.cells.push({
                        value: moment(log.dateAndTime).format("M/D/YY"),
                        key: `Cell-${log.id}-Date`,
                    })

                    // log type
                    logRow.cells.push({
                        value: "Shipped",
                        key: `Cell-${log.id}-LogType`,
                    })

                    // quantity
                    logRow.cells.push({
                        value: log.quantity,
                        key: `Cell-${log.id}-Quantity`,
                    })
                    
                    // calculate Shipped
                    shippedTotal += log.quantity
                }
    
                // receiving log
                else if(log.type == "receiving"){

                    // date
                    logRow.cells.push({
                        value: moment(log.dateAndTime).format("M/D/YY"),
                        key: `Cell-${log.id}-Date`,
                    })

                    // log type
                    logRow.cells.push({
                        value: "Received",
                        key: `Cell-${log.id}-LogType`,
                    })

                    // quantity
                    logRow.cells.push({
                        value: log.quantity,
                        key: `Cell-${log.id}-Quantity`,
                    })

                    // calculate Received
                    receivedTotal += log.quantity
                }

                mainRow.collapseTable.rows.push({...logRow})
            })

            // calculate Outstanding
            outstanding = shippedTotal - receivedTotal

            // add main cells
            mainRow.mainCells.push({
                value: shippedTotal,
                key: `mainCell-${equipmentItem.name}-shippedTotal`
            })

            mainRow.mainCells.push({
                value: receivedTotal,
                key: `mainCell-${equipmentItem.name}-receivedTotal`
            })

            mainRow.mainCells.push({
                value: outstanding,
                key: `mainCell-${equipmentItem.name}-outstanding`
            })

            rows.push({...mainRow})
        }
    })

    return rows
}